module.exports = __webpack_public_path__ + "media/images/sample-0af96dbad24ec2de70814aa045b26672.png";